module.exports = __webpack_public_path__ + "img/mc_photo.01ef9bce.png";